export const translations = {
  fr: {
    "nav.manifeste": "Manifeste",
    "nav.projets": "Projets",
    "nav.photo": "Photo",
    "nav.contact": "Contact",
    "menu.open": "MENU +",
    "menu.close": "FERMER ✕",
    "menu.loc": "BORDEAUX, FR — WORLDWIDE",
    "menu.role": "DIRECTION ARTISTIQUE",

    "hero.role": "Directrice Artistique",
    "hero.based": "Basée à Bordeaux — Ouverte à l'international",
    "hero.portfolio": "( Portfolio 2026 )",
    "hero.scroll": "SCROLL ↓",
    "hero.view": "Voir",

    "marquee.0": "Direction Artistique",
    "marquee.1": "Photographie",
    "marquee.2": "Identité Visuelle",
    "marquee.3": "Campagne",
    "marquee.4": "Édition",
    "marquee.5": "Scénographie",

    "manifesto.section": "Manifeste",
    "manifesto.fig": "FIG. 01 — AUTOPORTRAIT",
    "manifesto.intro":
      "Je suis Chloé — directrice artistique et photographe. Je fais dialoguer marques, images et émotions pour créer des campagnes qui laissent une trace.",
    "manifesto.c1.title": "L'image avant tout",
    "manifesto.c1.text":
      "Je construis des univers visuels qui racontent une histoire. Chaque projet commence par une intention : que doit ressentir le public avant même de lire le premier mot.",
    "manifesto.c2.title": "Le détail comme signature",
    "manifesto.c2.text":
      "Typographie, lumière, rythme, matière. La direction artistique vit dans les choix que personne ne remarque consciemment, mais que tout le monde ressent.",
    "manifesto.c3.title": "La photo, mon terrain de jeu",
    "manifesto.c3.text":
      "La photographie est ma pratique la plus personnelle. Argentique ou numérique, elle nourrit mon regard et infuse chacune de mes directions artistiques.",

    "projects.section": "Projets",
    "projects.selection": "SÉLECTION 2025 — 2026",
    "projects.reduce": "Réduire la sélection",
    "projects.viewOthers": "Voir les autres projets",
    "projects.hoverLabel": "Voir le projet →",

    "pp.allProjects": "TOUS LES PROJETS",
    "pp.film": "Film",
    "pp.motion": "MOTION",
    "pp.gallery": "Galerie — cliquez pour agrandir",
    "pp.visuals": "VISUELS",
    "pp.pages": "PAGES",
    "pp.nextProject": "Projet suivant",
    "pp.close": "FERMER",
    "pp.prev": "PRÉCÉDENT",
    "pp.next": "SUIVANT",

    "meta.Année": "Année",
    "meta.Équipe": "Équipe",
    "meta.Type": "Type",
    "meta.Support": "Support",
    "meta.École": "École",
    "meta.Palette": "Palette",
    "meta.Contexte": "Contexte",
    "meta.Outils": "Outils",
    "meta.Livrables": "Livrables",

    "photo.section": "Photo",
    "photo.subtitle": "MON TERRAIN PRÉFÉRÉ — {n} COLLECTIONS",
    "photo.allPhotos": "Toutes les photos",
    "photo.byCollection": "Par collection",
    "photo.viewMore": "Voir plus",
    "photo.viewLess": "Voir moins",
    "photo.openCollection": "Ouvrir la collection",
    "photo.nextCollection": "Collection suivante",
    "photo.clickEnlarge": "CLIQUEZ POUR AGRANDIR",
    "photo.photos": "PHOTOS",
    "photo.photo": "PHOTO",
    "photo.collab": "En collaboration avec",
    "photo.with": "avec",
    "photo.all": "Tout",

    "contact.section": "Contact",
    "contact.hookTop": "Un projet, une campagne, une idée ?",
    "contact.hookBottom": "Écrivons la suite ensemble.",
    "contact.name": "Nom",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.namePlaceholder": "Votre nom",
    "contact.emailPlaceholder": "votre@email.com",
    "contact.messagePlaceholder": "Parlez-moi de votre projet…",
    "contact.send": "Envoyer",
    "contact.sending": "Envoi…",
    "contact.success": "Message envoyé — je reviens vers vous très vite.",
    "contact.error": "Erreur lors de l'envoi, réessayez.",

    "footer.loc": "Bordeaux, FR — Ouverte à l'international",
    "footer.role": "Direction artistique & photo",
    "footer.backToTop": "Retour en haut ↑",
    "backtotop": "Haut de page",
  },
  en: {
    "nav.manifeste": "Manifesto",
    "nav.projets": "Projects",
    "nav.photo": "Photo",
    "nav.contact": "Contact",
    "menu.open": "MENU +",
    "menu.close": "CLOSE ✕",
    "menu.loc": "BORDEAUX, FR — WORLDWIDE",
    "menu.role": "ART DIRECTION",

    "hero.role": "Art Director",
    "hero.based": "Based in Bordeaux — Available worldwide",
    "hero.portfolio": "( Portfolio 2026 )",
    "hero.scroll": "SCROLL ↓",
    "hero.view": "View",

    "marquee.0": "Art Direction",
    "marquee.1": "Photography",
    "marquee.2": "Visual Identity",
    "marquee.3": "Campaign",
    "marquee.4": "Editorial",
    "marquee.5": "Set Design",

    "manifesto.section": "Manifesto",
    "manifesto.fig": "FIG. 01 — SELF-PORTRAIT",
    "manifesto.intro":
      "I'm Chloé — art director and photographer. I bring brands, images and emotions into dialogue to craft campaigns that leave a mark.",
    "manifesto.c1.title": "The image first",
    "manifesto.c1.text":
      "I build visual worlds that tell a story. Every project starts with an intention: what should the audience feel before they even read the first word.",
    "manifesto.c2.title": "Detail as a signature",
    "manifesto.c2.text":
      "Typography, light, rhythm, texture. Art direction lives in the choices no one consciously notices, yet everyone feels.",
    "manifesto.c3.title": "Photography, my playground",
    "manifesto.c3.text":
      "Photography is my most personal practice. Film or digital, it feeds my eye and infuses every one of my art directions.",

    "projects.section": "Projects",
    "projects.selection": "SELECTION 2025 — 2026",
    "projects.reduce": "Collapse selection",
    "projects.viewOthers": "View more projects",
    "projects.hoverLabel": "View project →",

    "pp.allProjects": "ALL PROJECTS",
    "pp.film": "Film",
    "pp.motion": "MOTION",
    "pp.gallery": "Gallery — click to enlarge",
    "pp.visuals": "VISUALS",
    "pp.pages": "PAGES",
    "pp.nextProject": "Next project",
    "pp.close": "CLOSE",
    "pp.prev": "PREVIOUS",
    "pp.next": "NEXT",

    "meta.Année": "Year",
    "meta.Équipe": "Team",
    "meta.Type": "Type",
    "meta.Support": "Format",
    "meta.École": "School",
    "meta.Palette": "Palette",
    "meta.Contexte": "Context",
    "meta.Outils": "Tools",
    "meta.Livrables": "Deliverables",

    "photo.section": "Photo",
    "photo.subtitle": "MY FAVOURITE PLAYGROUND — {n} COLLECTIONS",
    "photo.allPhotos": "All photos",
    "photo.byCollection": "By collection",
    "photo.viewMore": "See more",
    "photo.viewLess": "See less",
    "photo.openCollection": "Open collection",
    "photo.nextCollection": "Next collection",
    "photo.clickEnlarge": "CLICK TO ENLARGE",
    "photo.photos": "PHOTOS",
    "photo.photo": "PHOTO",
    "photo.collab": "In collaboration with",
    "photo.with": "with",
    "photo.all": "All",

    "contact.section": "Contact",
    "contact.hookTop": "A project, a campaign, an idea?",
    "contact.hookBottom": "Let's write what comes next, together.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.namePlaceholder": "Your name",
    "contact.emailPlaceholder": "your@email.com",
    "contact.messagePlaceholder": "Tell me about your project…",
    "contact.send": "Send",
    "contact.sending": "Sending…",
    "contact.success": "Message sent — I'll get back to you very soon.",
    "contact.error": "Something went wrong, please try again.",

    "footer.loc": "Bordeaux, FR — Available worldwide",
    "footer.role": "Art direction & photography",
    "footer.backToTop": "Back to top ↑",
    "backtotop": "Back to top",
  },
};
